<div class="flex flex-col gap-6">
  <span class="body-text-bold-gray">Set the time zone and date format for the system. The settings will apply to all dates and times shown.</span>

  <div class="flex flex-col gap-4">
    <span class="light-gray-heading">TIME ZONE</span>
    <lib-cdw-select
      [values]="timezoneValues"
      [label]="'Select Time Zone'"
      [placeholder]="'Choose a time zone'"
      [(ngModel)]="selectedTimeZone"
      (ngModelChange)="onTimeZoneChange($event)"
      [customTrigger]="selectedTimeZoneName"
      [inputWidth]="'400px'"
      [disabled]="isSaving"
    ></lib-cdw-select>
    @if (showTimezoneMismatchBanner) {
      <div class="flex items-center gap-1 body-text-sm">
        <lib-cdw-icon class="tz-mismatch-warning" icon="warning" size="18px"></lib-cdw-icon>
        <span>Auto-detected: <strong>{{ detectedBrowserTimezoneName }}</strong> &middot; <a class="text-blue-link hover:underline cursor-pointer font-normal [font-size:inherit]" [class.pointer-events-none]="isSaving" [class.opacity-50]="isSaving" (click)="applyBrowserTimezone()">Apply</a></span>
      </div>
    }
  </div>

  <div class="flex flex-col gap-2">
    <span class="light-gray-heading">DATE FORMAT</span>
    <lib-cdw-radio-group class="flex flex-col" [(ngModel)]="selectedDateFormat" (ngModelChange)="onDateFormatChange($event)" [disabled]="isSaving">
      <lib-cdw-radio-button class="flex flex-row" [value]="DateFormat.US" [name]="'dateFormat'" class="mb-2">
        <span class="body-text-black">US format = MM/DD/YY (06/29/24 for June 29, 2024)</span>
      </lib-cdw-radio-button>
      <lib-cdw-radio-button class="flex flex-row" [value]="DateFormat.CANADIAN" [name]="'dateFormat'">
        <span class="body-text-black">Canada/ISO Standard format = YYYY-MM-DD (2024-06-29 for June 29, 2024)</span>
      </lib-cdw-radio-button>
    </lib-cdw-radio-group>
  </div>

  <div>
    <lib-cdw-button
      mode="wide"
      [level]="'primary'"
      [disabled]="!hasChanges || isSaving"
      (buttonClick)="saveSettings()"
    >
      {{ isSaving ? 'Saving...' : 'Save Settings' }}
    </lib-cdw-button>
  </div>
</div>
